<div class="row">
	<span *ngIf="!this.resultExist">
		<span class="scania-icon-info xs"></span>
		<span class="bold">You are not authorized to view this test result</span>
	</span>
	<div class="col-md-12" *ngIf="this.resultExist">
		<div id="divTestResult" class="col-md-9">
			@if (environment !== TargetEnvironment.Hero) {
				<div class="col-md-4">
					<a href="{{ reportsurl }}reports?testRunUid={{ res?.testRunUid }}&fromDate={{ executionDateUTCString }}&toDate={{ executionDateUTCString }}" target="_blank">
						<u>
							<h5 class="scania-link no-margin" title="Link to Test Reports Web site">
								Create report for this test run
								<span class="scania-icon-report sm" style="padding-bottom: 20px"></span>
							</h5>
						</u>
					</a>
					<a href="{{ fenixReportsUrl }}reports?testRunUid={{ res?.testRunUid }}&fromDate={{ executionDateUTCString }}&toDate={{ executionDateUTCString }}" target="_blank">
						<u>
							<h5 class="scania-link no-margin" title="Link to Fenix Test Reports Web site">
								Create Fenix reports
								<span class="scania-icon-report sm" style="padding-bottom: 20px"></span>
							</h5>
						</u>
					</a>
				</div>
			} @else {
				<div class="col-md-4">
					<a href="{{ fenixReportsUrl }}reports?testRunUid={{ res?.testRunUid }}&fromDate={{ executionDateUTCString }}&toDate={{ executionDateUTCString }}" target="_blank">
						<u>
							<h5 class="scania-link no-margin" title="Link to Fenix Test Reports Web site">
								Create report for this test run
								<span class="scania-icon-report sm" style="padding-bottom: 40px"></span>
							</h5>
						</u>
					</a>
				</div>
			}
			<div style="text-align: right">
				<span [routerLink]="['/testcase/', res?.testCaseUid]" class="scania-link small-font" style="align-items: right">[View all results for this test case]</span>
			</div>
			<div id="divTestRunHeading" class="col-md-12 no-padding">
				<div class="results-heading">
					<h2>TEST RESULT: {{ res?.testCaseItemNo }} - {{ res?.testCaseName }}</h2>
				</div>
				<div class="results-heading-details">
					&nbsp;(version {{ res?.testCaseVersion }}) - {{ res?.executionTimeTestResult | date: 'yyyy-MM-dd HH:mm:ss' }} - {{ res?.vehicleName | uppercase }} -
					{{ res?.executedBy | uppercase }}
				</div>
			</div>
			<table mat-table [dataSource]="dataSource">
				<ng-container matColumnDef="result">
					<th mat-header-cell *matHeaderCellDef>Result</th>
					<td
						mat-cell
						*matCellDef="let element"
						[ngClass]="{
							failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
							failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
						}"
					>
						{{ element.result }}
					</td>
				</ng-container>
				<ng-container matColumnDef="troubleReports">
					<th mat-header-cell *matHeaderCellDef>Trouble reports</th>
					<td
						mat-cell
						*matCellDef="let element"
						[ngClass]="{
							failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
							failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
						}"
					>
						<i *ngIf="element.troubleReports.length > 0" class="scania-icon-trouble-report xs" title="Trouble reports exist"></i>
					</td>
				</ng-container>
				<ng-container matColumnDef="resultComment">
					<th mat-header-cell *matHeaderCellDef width="40%">Result comment</th>
					<td
						mat-cell
						*matCellDef="let element"
						[ngClass]="{
							failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
							failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
						}"
					>
						<span *ngIf="element.resultComment && element.resultText; else elseBlockResultComment">
							<button
								*ngIf="element.resultComment && element.resultText"
								mat-button
								(click)="$event.stopPropagation(); openDialog(element.resultComment, element.resultText)"
								class="icon-button"
								title="View result text"
							>
								<div class="icon-button-text">{{ element.resultComment }}</div>
								<div class="icon-button-icon"><mat-icon>more_horiz</mat-icon></div>
							</button>
						</span>
						<ng-template #elseBlockResultComment>
							<span *ngIf="element.resultComment">
								{{ element.resultComment }}
							</span>
						</ng-template>
						<div *ngIf="(res?.positiveComment !== '' && res?.positiveComment !== null) || (res?.negativeComment !== '' && res?.negativeComment !== null)">
							<table class="table-condensed no-margin">
								<tbody>
									<tr *ngIf="res?.positiveComment !== '' && res?.positiveComment !== null">
										<td class="no-padding" title="Positive comment">
											<span class="glyphicon glyphicon-ok-sign text-success"></span>
											{{ res?.positiveComment }}
										</td>
									</tr>
									<tr *ngIf="res?.negativeComment !== '' && res?.negativeComment !== null">
										<td class="no-padding" title="Negative comment">
											<span class="glyphicon glyphicon-remove-sign text-danger"></span>
											{{ res?.negativeComment }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</td>
				</ng-container>
				<ng-container matColumnDef="failedReasonText">
					<th mat-header-cell *matHeaderCellDef>Not executed reason</th>
					<td
						mat-cell
						*matCellDef="let element"
						[ngClass]="{
							failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
							failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
						}"
					>
						{{ element.failedReason === 0 ? '' : element.failedReasonText }}
					</td>
				</ng-container>
				<ng-container matColumnDef="failedBy">
					<th mat-header-cell *matHeaderCellDef width="10%">Not executed decided by</th>
					<td
						mat-cell
						*matCellDef="let element"
						[ngClass]="{
							failedreasonNANPBySystem: element.failedReason !== 0 && element.failedBy === 'System',
							failedreasonNANPByUser: element.failedReason !== 0 && element.failedBy !== 'System',
						}"
					>
						{{ element.failedBy }}
					</td>
				</ng-container>
				<ng-container matColumnDef="failedReasonComment">
					<th mat-header-cell *matHeaderCellDef>Not executed comment</th>
					<td mat-cell *matCellDef="let element">
						<span *ngIf="element.failedReasonComment && element.errorText; else elseBlockFailedReasonComment">
							<button
								*ngIf="element.failedReasonComment && element.errorText"
								mat-button
								(click)="$event.stopPropagation(); openDialog(element.failedReasonComment, element.errorText)"
								class="icon-button"
								title="View Not executed text"
							>
								<span class="icon-button-text">{{ element.failedReasonComment }}</span>
								<span class="icon-button-icon"><mat-icon>more_horiz</mat-icon></span>
							</button>
						</span>
						<ng-template #elseBlockFailedReasonComment>
							<span *ngIf="element.failedReasonComment">
								{{ element.failedReasonComment }}
							</span>
						</ng-template>
					</td>
				</ng-container>
				@if (environment !== TargetEnvironment.Hero) {
					<ng-container matColumnDef="testCaseAlternativeFailedReasons">
						<th mat-header-cell *matHeaderCellDef>Test case alternative: failed reason</th>
						<td mat-cell *matCellDef="let element">
							<table *ngIf="tcAlternativeFailedReasonsExist">
								<tr *ngFor="let failedReason of res?.testCaseAlternativeFailedReasons">
									<td class="no-padding">
										<span title="Derived from test case alternative: {{ failedReason.testCaseAlternativeName }} &#xA;with UID: {{ failedReason.testCaseAlternativeUid }}">
											{{ failedReason.testCaseAlternativeName }}: {{ failedReason.failedComment }}
											<span class="scania-icon-help xs" style="padding-bottom: 20px"></span>
										</span>
									</td>
								</tr>
							</table>
						</td>
					</ng-container>
				}
				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ failed: row.result === 'failed', passed: row.result === 'passed' }"></tr>
			</table>

			<mat-expansion-panel [expanded]="true" class="panel-margin" *ngIf="objectUnderTestExist">
				<mat-expansion-panel-header>
					<mat-panel-title>Objects under test</mat-panel-title>
				</mat-expansion-panel-header>
				<div id="divObjectsUnderTest" *ngIf="res?.testResultUid">
					<div *ngIf="res?.ecus.length > 0">
						<table class="table">
							<tbody>
								<tr *ngFor="let ecu of res?.ecus">
									<td width="20%">ECU</td>
									<td *ngIf="ecusInReadout?.includes(ecu.name)" class="bold no-padding" width="10%">{{ ecu.name }}</td>
									<td *ngIf="!ecusInReadout?.includes(ecu.name)" class="bold no-padding" width="10%" title="This ECU is not included in ECU identification readout, see panel below">
										{{ ecu.name }}
										<span class="scania-icon-warning xs"></span>
									</td>
									<td class="no-padding">{{ ecu.description }}</td>
									<td class="no-padding">{{ ecu.fpcCondition }}</td>
									<td class="no-padding">ECUFamily: {{ ecu.familyName }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div *ngIf="res?.offboardComponents.length > 0">
						<table class="table">
							<tbody>
								<tr *ngFor="let offboardComponent of res?.offboardComponents">
									<td width="20%">Offboard component</td>
									<td class="bold no-padding">{{ offboardComponent.value }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</mat-expansion-panel>

			<div id="divImages" *ngIf="files$ | async as files">
				<app-images [linkUid]="res?.linkUid"></app-images>
			</div>

			<mat-expansion-panel [expanded]="true" class="panel-margin" *ngIf="troubleReportsExist">
				<mat-expansion-panel-header>
					<mat-panel-title>
						<span class="scania-icon-trouble-report xs"></span>
						Trouble reports
						<span class="badge badge-default">{{ this.totalTroubleReports }}</span>
					</mat-panel-title>
				</mat-expansion-panel-header>
				<div id="divTroubleReports" *ngIf="res?.testResultUid">
					<app-trouble-reports [resultUid]="res?.testResultUid" (countTroubleReports)="showTroubleReportCounts($event)"></app-trouble-reports>
				</div>
			</mat-expansion-panel>

			<div id="divSteps" *ngIf="res?.testCaseUid && res?.inputType === inputTypePassFail">
				<app-test-case-steps [caseUid]="res?.testCaseUid" [caseVersion]="res?.testCaseVersion"></app-test-case-steps>
			</div>
			<br />

			<div>
				<button mat-button (click)="accordion.openAll()" class="btn btn-sm btn-primary">Expand all panels</button>
				<button mat-button (click)="accordion.closeAll()" class="btn btn-sm btn-default">Collapse all panels</button>
			</div>
			<mat-accordion multi>
				<div class="bottom-margin-small">
					<mat-expansion-panel [expanded]="true" class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>Test case details</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divTestCaseDetails" *ngIf="res?.testCaseUid">
							<app-test-case-details [testCaseUid]="res?.testCaseUid" [testCaseVersion]="res?.testCaseVersion" [tcversionchangeable]="false"></app-test-case-details>
						</div>
					</mat-expansion-panel>
				</div>
				<div class="bottom-margin-small" *ngIf="res?.testCaseUid">
					<mat-expansion-panel [expanded]="false" class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								Test case alternatives
								<span class="badge badge-default">{{ this.totalTestCaseAlternatives }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divAlternativesForTestCase">
							<app-test-case-alternative
								[testCaseUid]="res?.testCaseUid"
								[testCaseVersion]="res?.testCaseVersion"
								(countTestCaseAlternatives)="showTestCaseAlternatives($event)"
							></app-test-case-alternative>
						</div>
					</mat-expansion-panel>
				</div>
				<div class="bottom-margin-small" *ngIf="res?.testCaseUid">
					<mat-expansion-panel [expanded]="false" class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								Connected requirements to this test result for {{ res?.testCaseItemNo }} - {{ res?.testCaseName }} (version {{ res?.testCaseVersion }}) executed on
								{{ res?.executionTimeTestResult ? (res?.executionTimeTestResult | date: 'yyyy-MM-dd HH:mm:ss') : (res?.executionTimeTestRun | date: 'yyyy-MM-dd HH:mm:ss') }}
								<span class="badge badge-default">{{ this.totalRequirements }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divRequirementsForTestCase">
							<app-requirements
								[testCaseName]="res?.testCaseName"
								[testCaseUid]="res?.testCaseUid"
								[testCaseVersion]="res?.testCaseVersion"
								[testResultUid]="res?.testResultUid"
								(countRequirements)="showRequirements($event)"
							></app-requirements>
						</div>
					</mat-expansion-panel>
				</div>
				<div class="bottom-margin-small">
					<mat-expansion-panel class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								ECU identification readout (XCOM)
								<span class="badge badge-default">{{ this.totalEcuReadouts }}</span>
								<span *ngIf="this.originEcuReadout" class="small-font-italic">{{ this.originEcuReadout }}</span>
								<span *ngIf="this.fileTimeEcuReadout" class="small-font-italic">File creation time: {{ this.fileTimeEcuReadout | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divEcuReadouts" *ngIf="res?.testRunUid">
							@if (environment !== TargetEnvironment.Hero) {
								@if (xcomFiles$ | async; as files) {
									@if (files.length) {
										<app-attachments [files]="files" [hideImportTime]="ecuReadoutsFromDatabase"></app-attachments>
									}
								}
							}
							<app-ecu-readout (countEcuReadouts)="showEcuReadoutCounts($event)" (readoutsFromDatabase)="onReadoutsFromDatabase($event)"></app-ecu-readout>
						</div>
					</mat-expansion-panel>
				</div>
				<div class="bottom-margin-small">
					<mat-expansion-panel class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								E2 parameters
								<span class="badge badge-default">{{ this.totalEcuParams }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divEcuParams" *ngIf="res?.testRunUid">
							@if (environment !== TargetEnvironment.Hero) {
								@if (e2Files$ | async; as files) {
									@if (files.length) {
										<app-attachments [files]="files" [hideImportTime]="ecuParamsFromDatabase"></app-attachments>
									}
								}
							}
							<app-ecu-param (countEcuParams)="showEcuParamCounts($event)" (paramsFromDatabase)="onParamsFromDatabase($event)"></app-ecu-param>
						</div>
					</mat-expansion-panel>
				</div>
				<div class="bottom-margin-small">
					<mat-expansion-panel class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								Properties
								<span class="badge badge-default">{{ this.totalProperties }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divProperties" *ngIf="res?.testRunUid">
							<div>
								<button mat-button (click)="propertiesaccordion.openAll()" class="btn btn-sm btn-primary">Expand all Properties panels</button>
								<button mat-button (click)="propertiesaccordion.closeAll()" class="btn btn-sm btn-default">Collapse all Properties panels</button>
							</div>
							<mat-accordion #propertiesaccordion="matAccordion" multi>
								<mat-expansion-panel expanded="false" class="bottom-margin">
									<mat-expansion-panel-header>
										<mat-panel-title>
											Properties for test result
											<span class="badge badge-default">{{ this.totalResultProperties }}</span>
										</mat-panel-title>
									</mat-expansion-panel-header>
									<div *ngIf="res?.testResultUid">
										<app-test-result-properties [resultUid]="res?.testResultUid" (countResultProperties)="showResultPropertiesCount($event)"></app-test-result-properties>
									</div>
								</mat-expansion-panel>
								<mat-expansion-panel expanded="false" class="bottom-margin">
									<mat-expansion-panel-header>
										<mat-panel-title>
											Properties for test run
											<span class="badge badge-default">{{ this.totalRunProperties }}</span>
										</mat-panel-title>
									</mat-expansion-panel-header>
									<div *ngIf="res?.testRunUid">
										<app-test-run-properties [runUid]="res?.testRunUid" (countRunProperties)="showRunPropertiesCount($event)"></app-test-run-properties>
									</div>
								</mat-expansion-panel>
							</mat-accordion>
						</div>
					</mat-expansion-panel>
				</div>
				<div class="bottom-margin-small">
					<mat-expansion-panel class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>
								SOPS
								<span class="badge badge-default">{{ this.totalSOPS }}</span>
								<span *ngIf="this.originSOPS" class="small-font-italic">{{ this.originSOPS }}</span>
								<span *ngIf="this.fileTimeSOPS" class="small-font-italic">File creation time: {{ this.fileTimeSOPS | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
								<span *ngIf="this.versionSOPS" class="small-font-italic">File version: {{ this.versionSOPS }}</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divSOPS" *ngIf="res?.testRunUid">
							<app-sops
								[runUid]="res?.testRunUid"
								(countTotalSOPS)="showSOPSCounts($event)"
								(sopsOrigin)="showSOPSOrigin($event)"
								(sopsFileTime)="showSOPSFileTime($event)"
								(sopsVersion)="showSOPSVersion($event)"
								(sopsFPCs)="showSOPSFPCs($event)"
							></app-sops>
						</div>
					</mat-expansion-panel>
				</div>
				<div class="bottom-margin-small">
					<mat-expansion-panel class="bottom-margin">
						<mat-expansion-panel-header>
							<mat-panel-title>Offboard components</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="divDataComponents" *ngIf="res?.testRunUid">
							<app-offboard-component [runUid]="res?.testRunUid" (countOffboardComponents)="showOffboardComponentsCount($event)"></app-offboard-component>
						</div>
					</mat-expansion-panel>
				</div>
				@if (environment !== TargetEnvironment.Hero) {
					@if (files$ | async; as files) {
						<div class="bottom-margin-small">
							<mat-expansion-panel class="bottom-margin">
								<mat-expansion-panel-header>
									<mat-panel-title>
										Attachments
										<span class="badge badge-default">{{ files.length }}</span>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<div id="divAttachments" *ngIf="res?.testResultUid">
									@if (files.length) {
										<app-attachments [files]="files"></app-attachments>
									}
								</div>
							</mat-expansion-panel>
						</div>
					}
				}
			</mat-accordion>
			<br />
			<br />
		</div>

		<div id="TestResultAdditionalData" class="col-md-3">
			<div id="Environment" class="col-md-12 bottom-margin-small">
				<mat-expansion-panel [expanded]="true">
					<mat-expansion-panel-header>
						<mat-panel-title>Environment for test run</mat-panel-title>
					</mat-expansion-panel-header>
					@if (res?.vehicleName === 'No_Vehicle' || environment === TargetEnvironment.Hero) {
						<span>
							<h4>{{ res?.vehicleName }}</h4>
						</span>
					} @else if (res?.vehicleName !== 'No_Vehicle') {
						<span>
							<a href="https://testvehicle.scania.com/#/view;testCarrier={{ res?.vehicleName }}" target="_blank">
								<u>
									<h4
										class="scania-link"
										title="Link to TESTiT Test Vehicles site for this environment. Requires access which can be ordered from OrderIT. Not all environments are represented in TESTiT. "
									>
										{{ res?.vehicleName }}
									</h4>
								</u>
							</a>
						</span>
					}
					<div id="divEnvironment" *ngIf="FPCsSOPS?.length > 0">
						<app-environment [VINNo]="res?.vinNo" [FPCs]="FPCsSOPS"></app-environment>
					</div>
				</mat-expansion-panel>
			</div>
			<div id="divTestResultDetails" class="col-md-12">
				<mat-expansion-panel [expanded]="true">
					<mat-expansion-panel-header>
						<mat-panel-title>Test result details</mat-panel-title>
					</mat-expansion-panel-header>
					<table id="tableTestResultDetails" class="table-condensed" width="100%">
						<tbody width="100%">
							<tr title="If the result is going to be used (Valid) or not (Not valid)">
								<td width="40%">
									Classification
									<span class="scania-icon-help xs" style="padding-bottom: 20px"></span>
								</td>
								<td width="5px;"></td>
								<td *ngIf="classificationDescription === 'Valid'">{{ classificationDescription }}</td>
								<td *ngIf="classificationDescription === 'NotValid'">
									<span style="color: red">{{ classificationDescription }}</span>
								</td>
							</tr>
							<tr *ngIf="classificationReasonDescription !== 'OK'" title="What causes the test result to not be valid">
								<td>
									Classification reason
									<span class="scania-icon-help xs" style="padding-bottom: 20px"></span>
								</td>
								<td width="5px;"></td>
								<td>{{ classificationReasonDescription }}</td>
							</tr>
							<tr *ngIf="res?.classificationComment?.length > 0">
								<td>Classification comment</td>
								<td width="5px;"></td>
								<td>{{ res?.classificationComment }}</td>
							</tr>
							<tr>
								<td>Test result UID</td>
								<td width="5px;"></td>
								<td>{{ res?.testResultUid }}</td>
							</tr>
							<tr>
								<td>Test run UID</td>
								<td width="5px;"></td>
								<td>{{ res?.testRunUid }}</td>
							</tr>
							<tr *ngIf="res?.testScriptName">
								<td>Test script name</td>
								<td width="5px;"></td>
								<td>{{ res?.testScriptName }}</td>
							</tr>
							<tr *ngIf="res?.testScriptVersion">
								<td>Test script version</td>
								<td width="5px;"></td>
								<td>{{ res?.testScriptVersion }}</td>
							</tr>
							<!-- <tr>
                <td>UC</td>
                <td width="5px;"></td>
                <td>{{res?.UC}}</td>
            </tr>
            <tr>
                <td>UF</td>
                <td width="5px;"></td>
                <td>{{res?.UF}}</td>
            </tr>
            <tr>
                <td>SCN</td>
                <td width="5px;"></td>
                <td>{{res?.SCN}}</td>
            </tr> -->
							<tr>
								<td>Test run execution time</td>
								<td width="5px;"></td>
								<td>{{ res?.executionTimeTestRun | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
							</tr>
							<tr>
								<td>Executed by</td>
								<td width="5px;"></td>
								<td style="word-wrap: break-word">{{ res?.executedBy }}</td>
							</tr>
							<!-- <tr>
                <td>Execution location</td>
                <td width="5px;"></td>
                <td>{{res?.ExecutionLocation}}</td>
            </tr>     -->
							<tr
								class="top-border scania-link"
								[routerLink]="['/testcasedetails']"
								[queryParams]="{ uid: res?.testCaseUid, version: res?.testCaseVersion }"
								title="Show test case details page"
							>
								<td class="scania-link"><u>Test case ItemNo</u></td>
								<td class="scania-link" width="5px;"></td>
								<td class="bold scania-link">
									<u>{{ res?.testCaseItemNo }}</u>
								</td>
							</tr>
							<tr class="scania-link" [routerLink]="['/testcasedetails']" [queryParams]="{ uid: res?.testCaseUid, version: res?.testCaseVersion }" title="Show test case details page">
								<td class="scania-link"><u>Test case</u></td>
								<td class="scania-link" width="5px;"></td>
								<td class="bold scania-link">
									<u>{{ res?.testCaseName }}</u>
								</td>
							</tr>
							<tr class="scania-link" [routerLink]="['/testcasedetails']" [queryParams]="{ uid: res?.testCaseUid, version: res?.testCaseVersion }" title="Show test case details page">
								<td class="scania-link"><u>Test case UID</u></td>
								<td class="scania-link" width="5px;"></td>
								<td class="bold scania-link">
									<u>{{ res?.testCaseUid }}</u>
								</td>
							</tr>
							<tr>
								<td>Test case version</td>
								<td width="5px;"></td>
								<td>{{ res?.testCaseVersion }}</td>
							</tr>
						</tbody>
					</table>
					<table class="table-condensed" width="100%">
						<tbody width="100%">
							<span *ngIf="res?.testRunType === 410; else elseBlockResultDetails">
								<tr
									class="scania-link"
									[routerLink]="['/testspecificationdetails']"
									[queryParams]="{ uid: res?.testSpecificationUid, version: res?.testSpecificationVersion }"
									title="Show test specification details page"
								>
									<td class="scania-link" width="40%">Test specification ItemNo</td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">{{ res?.testSpecificationItemNo }}</td>
								</tr>
								<tr
									class="scania-link"
									[routerLink]="['/testspecificationdetails']"
									[queryParams]="{ uid: res?.testSpecificationUid, version: res?.testSpecificationVersion }"
									title="Show test specification details page"
								>
									<td class="scania-link" width="40%">Test specification</td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">{{ res?.testSpecificationName }}</td>
								</tr>
								<tr
									class="scania-link"
									[routerLink]="['/testspecificationdetails']"
									[queryParams]="{ uid: res?.testSpecificationUid, version: res?.testSpecificationVersion }"
									title="Show test specification details page"
								>
									<td class="scania-link">Test specification UID</td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ res?.testSpecificationUid }}</u>
									</td>
								</tr>
								<tr>
									<td>Test specification version</td>
									<td width="5px;"></td>
									<td>{{ res?.testSpecificationVersion }}</td>
								</tr>
							</span>
							<ng-template #elseBlockResultDetails>
								<tr
									class="top-border scania-link"
									[routerLink]="['/testsuitedetails']"
									[queryParams]="{ uid: res?.testSuiteUid, version: res?.testSuiteVersion }"
									title="Show test suite details page"
								>
									<td class="scania-link" width="40%"><u>Test suite ItemNo</u></td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ res?.testSuiteItemNo }}</u>
									</td>
								</tr>
								<tr
									class="scania-link"
									[routerLink]="['/testsuitedetails']"
									[queryParams]="{ uid: res?.testSuiteUid, version: res?.testSuiteVersion }"
									title="Show test suite details page"
								>
									<td class="scania-link" width="40%"><u>Test suite</u></td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ res?.testSuiteName }}</u>
									</td>
								</tr>
								<tr
									class="scania-link"
									[routerLink]="['/testsuitedetails']"
									[queryParams]="{ uid: res?.testSuiteUid, version: res?.testSuiteVersion }"
									title="Show test suite details page"
								>
									<td class="scania-link"><u>Test suite UID</u></td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ res?.testSuiteUid }}</u>
									</td>
								</tr>
								<tr>
									<td>Test suite version</td>
									<td width="5px;"></td>
									<td>{{ res?.testSuiteVersion }}</td>
								</tr>
								<tr
									*ngIf="res?.mainTestSuiteName"
									class="top-border scania-link"
									[routerLink]="['/testsuitedetails']"
									[queryParams]="{ uid: res?.mainTestSuiteUid, version: res?.mainTestSuiteVersion }"
									title="Show main test suite details"
								>
									<td class="scania-link"><u>Main test suite ItemNo</u></td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ res?.mainTestSuiteItemNo }}</u>
									</td>
								</tr>
								<tr
									*ngIf="res?.mainTestSuiteName"
									class="scania-link"
									[routerLink]="['/testsuitedetails']"
									[queryParams]="{ uid: res?.mainTestSuiteUid, version: res?.mainTestSuiteVersion }"
									title="Show main test suite details"
								>
									<td class="scania-link"><u>Main test suite</u></td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ res?.mainTestSuiteName }}</u>
									</td>
								</tr>
								<tr
									*ngIf="res?.mainTestSuiteName"
									class="scania-link"
									[routerLink]="['/testsuitedetails']"
									[queryParams]="{ uid: res?.mainTestSuiteUid, version: res?.mainTestSuiteVersion }"
									title="Show main test suite details"
								>
									<td class="scania-link"><u>Main test suite UID</u></td>
									<td class="scania-link" width="5px;"></td>
									<td class="bold scania-link">
										<u>{{ res?.mainTestSuiteUid }}</u>
									</td>
								</tr>
								<tr *ngIf="res?.mainTestSuiteVersion">
									<td>Main test suite version</td>
									<td width="5px;"></td>
									<td>{{ res?.mainTestSuiteVersion }}</td>
								</tr>
							</ng-template>
						</tbody>
					</table>
				</mat-expansion-panel>
			</div>
		</div>
	</div>
</div>
